import { useDispatch } from "react-redux";
import AppService from "~/services/AppService";
import { ANGULAR_INIT } from "~/store/action_types";

export function useGetInitial() {
  const dispatch = useDispatch();
  return async () => {
    const initial = await AppService.getInitial();
    const { settings: config_options } = initial;
    return dispatch({
      type: ANGULAR_INIT,
      response: { config_options },
    });
  };
}
